import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { ComparisonSelector, PersistenceHelper } from '@best-buy/lib-compare-tray';

export class ComparisonSelectorMxPDP extends React.Component {
	constructor (props, context) {
		super(props, context);

		// Optionally setting eventManager on props makes testing easier
		this.eventManager = props.eventManager;
		this.onAdded = this.onAdded.bind(this);
		this.onRemoved = this.onRemoved.bind(this);
		this.setSkuState = this.setSkuState.bind(this);

		this.state = {
			comparedSkus: []
		};
	}

	componentDidMount () {
		if (!this.eventManager) {
			// If event manager is not set yet, assume we're using the client side version
			this.eventManager = window.EventManager;
		}

		this.setSkuState();

		this.eventManager.on('compare-tray:add-item', this.setSkuState);
		this.eventManager.on('compare-tray:remove-item', this.setSkuState);
		this.eventManager.on('compare-tray:remove-all', this.setSkuState);
	}

	onAdded () {
		this.eventManager.trigger('compare-tray:add-item', this.props.sku);
	}

	onRemoved () {
		this.eventManager.trigger('compare-tray:remove-item', this.props.sku.skuId);
	}

	setSkuState () {
		this.setState({
			comparedSkus: PersistenceHelper.getInstance().getCompareItems()
		});
	}

	render () {
		const { translations = {}, sku = {}, deviceClass = 'l', enableCompare = true } = this.props;
		const { comparedSkus = [] } = this.state;

		if (!enableCompare) {
			return null;
		}

		return (
			<div className="comparison-selector-mx-pdp-container">
				<ComparisonSelector
					sku={sku}
					comparedSkus={comparedSkus}
					onAdded={this.onAdded}
					onRemoved={this.onRemoved}
					deviceClass={deviceClass}
					translations={translations} />
			</div>
		);
	}
}

export default translate(['common'])(ComparisonSelectorMxPDP);

ComparisonSelectorMxPDP.propTypes = {
	t: PropTypes.func.isRequired,
	sku: PropTypes.shape({
		skuId: PropTypes.string.isRequired
	}),
	comparedSkus: PropTypes.array,
	deviceClass: PropTypes.string,
	enableCompare: PropTypes.bool,
	eventManager: PropTypes.object,
	translations: PropTypes.object,
};



// WEBPACK FOOTER //
// ./client/components/app/index.js